// extracted by mini-css-extract-plugin
module.exports = {"detail":"Detail_detail__73PlZ","label":"Detail_label__3mgSb","value":"Detail_value__z7Tj0"};